var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTrainNumber = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 76,
  height: 42,
  viewBox: "0 0 76 42"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "train-number_svg__a",
  width: "157.6%",
  height: "221.4%",
  x: "-28.8%",
  y: "-46.4%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 4,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
})), /*#__PURE__*/React.createElement("rect", {
  id: "train-number_svg__b",
  width: 59,
  height: 28,
  x: 8.5,
  y: 6,
  rx: 2
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#train-number_svg__b",
  fill: "#000",
  filter: "url(#train-number_svg__a)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#train-number_svg__b",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("text", {
  fill: "#0B2545",
  fontFamily: "Manrope-Regular, Manrope",
  fontSize: 14,
  textAnchor: "middle"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 38,
  y: 25
}, "9077I")))));
export default SvgTrainNumber;